import { forwardRef, type InputHTMLAttributes } from 'react';
import { Search } from 'lucide-react';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  width?: number | string;
}

/**
 * Search-styled input: `--canvas-inset` track, no border, 8px radius, leading search icon. Controlled
 * by the caller (pass `value` + `onChange`).
 */
export const SearchInput = forwardRef<HTMLInputElement, Props>(function SearchInput(
  { width = 280, className = '', style, placeholder = 'Search…', ...rest },
  ref,
) {
  return (
    <div className="relative inline-flex items-center" style={{ width, ...style }}>
      <Search className="pointer-events-none absolute left-3 h-4 w-4 text-text-muted" aria-hidden />
      <input
        ref={ref}
        type="search"
        placeholder={placeholder}
        className={`h-9 w-full rounded-lg border-0 pl-9 pr-3 text-[13px] text-text placeholder:text-text-subtle focus:outline-none focus:ring-2 focus:ring-brand/30 ${className}`}
        style={{ background: 'var(--canvas-inset)' }}
        {...rest}
      />
    </div>
  );
});
